import { useAppStore } from "@/global/store";
import {
  gameFiltersState,
  selectSeatCount,
} from "@/global/store/data/gameFilters";
import { Counter } from "@/shared/base/components/Counter/Counter";
import { Box, Typography } from "@mui/material";
import { useDispatch, useStore } from "react-redux";
import { calcMaxSeatLimit } from "../utils.gameFilters";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { useSelectActiveEvent } from "../../PurchaseSeats/ChooseSeats/useSelectActiveEvent";
import { useFilterPanelsState } from "../useFilterPanels";

interface Props {
  renderFooter: () => React.ReactElement;
}

export function SeatCounter(props: { title?: string; description?: string }) {
  const dispatch = useDispatch();
  const teamConfig = useTeamConfig();
  const {
    purchaseSeatConfigs: { minSeatLimit },
  } = teamConfig;
  const seatCount = useAppStore(selectSeatCount);
  const { activeEvent } = useSelectActiveEvent();
  const maxSeatCount = calcMaxSeatLimit(activeEvent, teamConfig);
  const { set: setFilterPanelsState } = useFilterPanelsState();

  const handleChange = (value: number) => {
    if (value >= minSeatLimit && value <= maxSeatCount) {
      dispatch(
        gameFiltersState.actions.setByKeys({
          keys: ["seatCount"],
          value,
        })
      );
    }
    setFilterPanelsState({
      lastChangedFilter: "seat_counter",
    });
  };

  return (
    <Box>
      <Box>
        {props?.title ? (
          <Box>
            <Typography
              variant="subtitle1"
              fontWeight={"700"}
              color="text.primary"
            >
              {props?.title}
            </Typography>
          </Box>
        ) : null}

        {props?.description ? (
          <Box>
            <Typography variant="body1" color="text.primary">
              {props?.description}
            </Typography>
          </Box>
        ) : null}

        <Box mt={2}>
          <Counter
            value={seatCount}
            onChange={handleChange}
            isDisabledPlus={seatCount === maxSeatCount}
            isDisabledMinus={seatCount <= minSeatLimit}
          />
        </Box>
      </Box>
    </Box>
  );
}
